module.exports = __webpack_public_path__ + "static/media/AIWorkshopSpacesIcon.aa1711e6.svg";